<div class="form-row">
  <div class="col">
    <div class="row">
      <div class="col">
        <label for="inputEmail4">Name</label>
        <input type="text" name='name' [(ngModel)]='this.container.name' [class.is-invalid]='!this.container.name' class="form-control" id="inputEmail4">
      </div>
      <div class="col">
        <label for="inputPassword4">Serial Number</label>
        <input type="text" name='registration' (ngModelChange)='this.container.name = this.container.serialNumber' [class.is-invalid]='!this.container.name' [(ngModel)]='this.container.serialNumber'  class="form-control" id="inputPassword4">
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for="inputPassword4">Container Group</label>
        <select class='form-control' [class.is-invalid]='this.container.containerGroupId === -1' (change)='this.container.containerGroupId = +$event.target.value; this.container.containerGroup.id = this.container.containerGroupId'>
          <option value='-1'>Select a Container Group</option>
          @for (item of this.groups; track item) {
            <option [value]='item.id' [selected]='this.container.containerGroupId === item.id'>{{ item.name }}</option>
          }
        </select>
      </div>
      <div class="col">
        <label for="inputPassword4">Container Type</label>
        <select class='form-control' [class.is-invalid]='this.container.containerTypeId === -1' (change)='this.container.containerTypeId = +$event.target.value; this.container.containerType.id = this.container.containerTypeId;populateName()'>
          <option value='-1'>Select a Container Type</option>
          @for (item of this.types; track item) {
            <option [value]='item.id' [selected]='this.container.containerTypeId === item.id'>{{ item.name }}</option>
          }
        </select>
      </div>
    </div>
    <div class="row">
      @if (this.container.containerGroupId < 3 || this.container.containerGroupId > 4) {
        <div class="col">
          <label for="inputPassword4">Container Size</label>
          <select class='form-control' [class.is-invalid]='this.container.containerSizeTypeId === -1' (change)='this.container.containerSizeTypeId = +$event.target.value; this.container.containerSizeType.id = this.container.containerSizeTypeId'>
            <option value='-1'>Select a Container Type</option>
            @for (item of this.sizes; track item) {
              <option [value]='item.id' [selected]='this.container.containerSizeTypeId === item.id'>{{ item.size }} {{ item.unit.name }}</option>
            }
          </select>
        </div>
      }
      <div class="col">
        <label>Active?</label>
        <input type='checkbox'
          [(ngModel)]="this.container.active"
          [ngModelOptions]="{standalone: true}"/>
      </div>
    </div>

    <div class='row'>
      <div class='col'>
        <br />
        <label>
          Allowed grades
        </label>
        <ng-select
          [items]="this.grades"
          bindLabel="name"
          [multiple]="true"
          [closeOnSelect]="false"
          [compareWith]="compareById"
          placeholder="Select grades (non required)"
          [(ngModel)]="containerGrades.grades">
          <ng-template ng-header-tmp>
            <button type="button" class="btn btn-sm btn-link" (click)="containerGrades.grades = this.grades.slice()">Select All</button>
            <button type="button" class="btn btn-sm btn-link" (click)="containerGrades.grades = []">UnSelect All</button>
          </ng-template>
        </ng-select>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <br />
        <label for="inputPassword4">Notes</label>
        <textarea name='notes' [(ngModel)]='this.container.notes' class="form-control"></textarea>
      </div>
    </div>


  </div>
  <div class="col-4">
    <div class="col">
      <app-qr-gen [input]='this.pageRoute' [size]='this.qrSize'></app-qr-gen>
    </div>
  </div>
</div>
